import React, {useEffect} from 'react';
import {useNavigate} from "react-router-dom";
import Service from "../components/Service";


const ProductProfilePage = () => {
    const navigate = useNavigate();
    const config = window.APP_CONFIG;


    useEffect(() => {

        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;

        if(token) {
            if(window.localStorage.getItem("needRegistration") === '1'){
                navigate('/register');
            }
        }
        else {
            if(config.service_app_settings.need_login > 0 ) {
                navigate('/login', { replace: true });
            }
        }

    }, []);


    return (
        <React.Fragment>
            <Service />
        </React.Fragment>
    );
};

export default ProductProfilePage;